import { render, staticRenderFns } from "./DeleteModel.vue?vue&type=template&id=304398db&"
import script from "./DeleteModel.vue?vue&type=script&lang=js&"
export * from "./DeleteModel.vue?vue&type=script&lang=js&"
import style0 from "./DeleteModel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports